import cs from "element-plus/es/locale/lang/cs";

export default {
  ...cs,
  el: {
    ...cs.el,
    datepicker: {
      ...cs.el.datepicker,
      year: "", // Do not show "year" label in datepicker
    },
  },
};
